__webpack_require__.p = "https://cdn-vn.mygobiz.net/gobiz-amphitrite/2.1019.1019.RELEASE/";